import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/tokyo_growth_logo.png")